import React from 'react'
import { Switch } from 'antd'
import { AntdFormItem, AntdFormItemProps } from '@/common/components/AntdForm/AntdFormItem.tsx'
import { cn } from '@/utils/style.ts'

type AntdFormSwitchProps = {
  className?: string
} & AntdFormItemProps

export const AntdFormSwitch: React.FC<AntdFormSwitchProps> = ({
  fieldProps,
  className,
  ...props
}) => {
  return (
    <AntdFormItem {...fieldProps} normalize={values => !!values}>
      <Switch {...props} className={cn(className)} />
    </AntdFormItem>
  )
}
